export default "__VITE_ASSET__BGLJE3Uu__"